module.exports = __webpack_public_path__ + "img/Lbbwk7FK_400x400.b1f2a5d0.png";